export default function PoliciesSection({property} : any) {
  const policies = [
    {
      title: "Normas de la casa",
      items: [
        `Check-in: ${property.checkin[0]?.time ?? 'Sin horario'}`,
        `Check-out: ${property.checkout[0]?.time ?? 'Sin horario'}`,
        `${property.travellers} huéspedes como máximo`,
        "Se permiten mascotas",
      ],
    },
  ]

  return (
    <div className="space-y-8">
      {policies.map((policy, index) => (
        <div key={index}>
          <h3 className="text-lg font-semibold mb-3">{policy.title}</h3>
          <ul className="space-y-2">
            {policy.items.map((item, itemIndex) => (
              <li key={itemIndex} className="text-gray-700 text-sm">
                {item}
              </li>
            ))}
          </ul>
          {index < policies.length - 1 && (
            <div className="text-[#8B9456] text-sm mt-2 cursor-pointer hover:underline">Ver más ▸</div>
          )}
        </div>
      ))}
    </div>
  )
}
